<template lang="pug">
#difference_service
  description(:description="currentDifferentInfo")
  media-img.golden_line_up(:imgUrl="'golden_line_up'")
  section.container-fluid.bg_light_blue.i_pt_8.i_pt_md_6.i_pb_16
    .container
      .row
        .col-12.text-center
          h2.i_h2_title 差異化服務接軌
      .row
        .col-12.i_mt_6(
          v-for="(service, index) in currentDifferentServieceList"
        )
          service-card(@openDialog="openDialog", :item="service")
  media-img.golden_line_up(:imgUrl="'golden_line_up'")
  section.container
    h2.i_h2_title.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
    p.i_body_l.text-center(v-if="false") 也歡迎至「
      span
        router-link(
          tag="a",
          :to="{ name: 'CustomerServiceContactUs' }",
          style="cursor: pointer; color: #009ce5"
        ) 聯絡我們
      | 」留下問題，將有專人主動聯繫回覆您
    .row
      .col-6.col-md-3.i_mt_8.i_mt_md_4(
        v-for="(question, index) in questions",
        :key="index",
        v-if="getFAQAmount(index)"
      )
        question(:question="question")
    .row.text-center
      router-link.i_mtb_10.see_more_btn.sm.btn_blue_ci(
        tag="a",
        :to="{ name: 'CustomerServiceFAQ' }"
      ) 看更多
  custom-footer
  dialog-html(
    v-if="dialogShow",
    @closeDialog="closeDialog",
    :detail="cardDetail"
  )
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import Description from "@/components/difference_service/Description";
import MediaImg from "@/components/common/MediaImg";
import ServiceCard from "@/components/customer_service/ServiceCard";
import Question from "@/components/common/Question";
import DialogHtml from "@/components/common/dialog/DialogHtml";
import { getFAQDetail } from "@/json/FAQ";
import {
  getDifferentServiceList,
  getDifferentServiceInfo,
} from "@/json/different";
import { stopScroll, startScroll } from "@/utils/scroll";

export default {
  name: "DifferenceService",
  components: {
    Description,
    MediaImg,
    ServiceCard,
    question: Question,
    "custom-footer": CustomFooter,
    DialogHtml,
  },
  data() {
    return {
      dialogShow: false,
      currentDifferentServieceList: [],
      differenceServiceInfoList: [],
      currentDifferentInfo: {},
      questions: [],
      cardDetail: {},
    };
  },
  created() {
    this.getDifferentServiceInfo();
  },
  methods: {
    openDialog(object) {
      this.cardDetail = object;
      this.dialogShow = true;
      stopScroll();
    },
    closeDialog() {
      this.dialogShow = false;
      startScroll();
    },
    getDifferentServiceInfo() {
      getDifferentServiceInfo().then((response) => {
        this.differenceServiceInfoList = response.data.DifferentServiceInfoList;

        for (let index in this.differenceServiceInfoList) {
          let temp = this.differenceServiceInfoList[index];
          if (this.$route.params.id == temp.ProductID) {
            this.currentDifferentInfo = temp;
          }
        }
        this.getFAQDetail();
        getDifferentServiceList().then((response) => {
          this.differentServiceList = response.data.DifferentServiceList;
          this.getCurrentDifferentServiceList();
        });
      });
    },
    getCurrentDifferentServiceList() {
      if (
        this.currentDifferentInfo.DifferentServiceList &&
        this.currentDifferentInfo.DifferentServiceList.length > 0
      ) {
        for (let x in this.currentDifferentInfo.DifferentServiceList) {
          let id = this.currentDifferentInfo.DifferentServiceList[x];
          for (let y in this.differentServiceList) {
            let temp = this.differentServiceList[y];
            if (id == temp.ID) {
              this.currentDifferentServieceList.push(temp);
            }
          }
        }
      }
    },
    getFAQDetail() {
      this.FAQDetail = [];
      getFAQDetail().then((response) => {
        this.FAQDetail = response.data.FAQDeatilList;
        for (let index in this.FAQDetail) {
          let tempFAQ = this.FAQDetail[index];
          if (this.currentDifferentInfo.FAQ01ID == tempFAQ.FAQID) {
            this.FAQ1Detail = tempFAQ;
          }
          if (this.currentDifferentInfo.FAQ02ID == tempFAQ.FAQID) {
            this.FAQ2Detail = tempFAQ;
          }
          if (this.currentDifferentInfo.FAQ03ID == tempFAQ.FAQID) {
            this.FAQ3Detail = tempFAQ;
          }
          if (this.currentDifferentInfo.FAQ04ID == tempFAQ.FAQID) {
            this.FAQ4Detail = tempFAQ;
          }
        }
        this.questions.push(this.FAQ1Detail);
        this.questions.push(this.FAQ2Detail);
        this.questions.push(this.FAQ3Detail);
        this.questions.push(this.FAQ4Detail);
      });
    },
    getFAQAmount(index) {
      if (this.$store.state.screenWidth > 767 && index < 4) {
        return true;
      } else if (this.$store.state.screenWidth < 768 && index < 2) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/difference_service/difference_service";
</style>
